// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Cairo";
  src: local("Cairo"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Cairo";
}

::selection {
  background-color: #750a00;
  color: white;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-color: #750a00;
  transition: background-color 0.2s ease-in-out;
  border-radius: 0.5rem;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #750a00ec;
}

.ant-menu .ant-menu-inline.ant-menu-sub {
  background: white !important;
}

.ant-menu .ant-menu-sub.ant-menu-vertical {
  background: white !important;
}

.ant-menu-light.ant-menu-root.ant-menu-inline {
  border-inline-end: 0px !important;
}

.ant-menu-light.ant-menu-root.ant-menu-vertical {
  border-inline-end: 0px !important;
}

.spinner-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.editable-cell-value-wrap:hover {
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
  text-align: center;
  display: flex;
  justify-content: center;
  /* direction: ltr; */
  transition: all ease-in-out;
  cursor: pointer;
  padding-right: 0px !important;
  touch-action: manipulation; /* Disable pinch-zoom */
}

.editable-cell-value-wrap {
  padding-right: 0px !important;
  touch-action: manipulation; /* Disable pinch-zoom */
}

.report-header {
  color: #222f3e;
  font-weight: bolder;
  font-size: 1rem;
}

.report-row:nth-child(even) {
  background-color: rgba(211, 211, 211, 0.127);
}

.regular-row:nth-child(even) {
  background-color: rgba(211, 211, 211, 0.259);
}

.ant-table-tbody > tr.ant-table-row.report-row:hover > td {
  background: #ebfbff7a !important; /* Your desired hover color */
}
.ant-picker-panels {
  direction: rtl !important;
}

@media (max-width: 768px) {
  .ant-picker-panels {
    flex-direction: column !important;
  }
}

.simple-keyboard .hg-button {
  margin: 5px; /* Adjust spacing */
  padding: 15px 20px; /* Adjust button size */
  border-radius: 8px; /* Round corners */
  background-color: #f0f0f0; /* Light background */
  font-size: 18px; /* Adjust text size */
  font-weight: bold;
}

.simple-keyboard .hg-button[data-skbtn="{enter}"] {
  background-color: #750a00;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;8DAC4D;AAC9D;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,6BAA6B;EAC7B,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC,EAAE,6BAA6B;AACjE;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW,EAAE,mBAAmB;EAChC,kBAAkB,EAAE,uBAAuB;EAC3C,kBAAkB,EAAE,kBAAkB;EACtC,yBAAyB,EAAE,qBAAqB;EAChD,eAAe,EAAE,qBAAqB;EACtC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["@font-face {\n  font-family: \"Cairo\";\n  src: local(\"Cairo\"),\n    url(\"./assets/fonts/Cairo-Regular.ttf\") format(\"truetype\");\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Cairo\";\n}\n\n::selection {\n  background-color: #750a00;\n  color: white;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background-color: #750a00;\n  transition: background-color 0.2s ease-in-out;\n  border-radius: 0.5rem;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background-color: #750a00ec;\n}\n\n.ant-menu .ant-menu-inline.ant-menu-sub {\n  background: white !important;\n}\n\n.ant-menu .ant-menu-sub.ant-menu-vertical {\n  background: white !important;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-inline {\n  border-inline-end: 0px !important;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border-inline-end: 0px !important;\n}\n\n.spinner-container {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.editable-cell-value-wrap:hover {\n  border-bottom: 1px solid lightgray;\n  padding-bottom: 5px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  /* direction: ltr; */\n  transition: all ease-in-out;\n  cursor: pointer;\n  padding-right: 0px !important;\n  touch-action: manipulation; /* Disable pinch-zoom */\n}\n\n.editable-cell-value-wrap {\n  padding-right: 0px !important;\n  touch-action: manipulation; /* Disable pinch-zoom */\n}\n\n.report-header {\n  color: #222f3e;\n  font-weight: bolder;\n  font-size: 1rem;\n}\n\n.report-row:nth-child(even) {\n  background-color: rgba(211, 211, 211, 0.127);\n}\n\n.regular-row:nth-child(even) {\n  background-color: rgba(211, 211, 211, 0.259);\n}\n\n.ant-table-tbody > tr.ant-table-row.report-row:hover > td {\n  background: #ebfbff7a !important; /* Your desired hover color */\n}\n.ant-picker-panels {\n  direction: rtl !important;\n}\n\n@media (max-width: 768px) {\n  .ant-picker-panels {\n    flex-direction: column !important;\n  }\n}\n\n.simple-keyboard .hg-button {\n  margin: 5px; /* Adjust spacing */\n  padding: 15px 20px; /* Adjust button size */\n  border-radius: 8px; /* Round corners */\n  background-color: #f0f0f0; /* Light background */\n  font-size: 18px; /* Adjust text size */\n  font-weight: bold;\n}\n\n.simple-keyboard .hg-button[data-skbtn=\"{enter}\"] {\n  background-color: #750a00;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
